<template>
  <div class="class-of-position-simulator-template" theme>
    <div id="class-of-position-simulator-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'manager',
      parts: [
        {
          elem: '#class-of-position-simulator-content',
          htmlFile: 'classOfPositionSimulator'
        }
      ]
    }
  }
}
</script>
